import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom } from '@angular/core';
import { InMemoryScrollingOptions, provideRouter, withInMemoryScrolling, withRouterConfig } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { CustomMatPaginatorIntl, LoadingInterceptor, User, UserService } from '@wm-libs/core';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { StorageService } from '@wm-libs/core';
import { Observable, switchMap } from 'rxjs';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { createTranslateLoader } from '@wm-libs/core';
import { TokenInterceptor } from '@wm-libs/core';
import { ErrorInterceptor } from '@wm-libs/core';
import { MAT_RIPPLE_GLOBAL_OPTIONS, MatNativeDateModule, RippleGlobalOptions } from '@angular/material/core';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { SsrCookieService } from 'ngx-cookie-service-ssr';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { MatPaginatorIntl } from '@angular/material/paginator';

function initializeAppFactory(userService: UserService, translate: TranslateService, storageService: StorageService): () => Observable<User | boolean> {
  return (): Observable<User | boolean> => {
    const lang = storageService.getUserLang() || 'en';

    return translate.use(lang).pipe(switchMap(() => userService.getUser()));
  };
}

const scrollConfig: InMemoryScrollingOptions = {
  scrollPositionRestoration: 'top',
};

const globalRippleConfig: RippleGlobalOptions = {
  disabled: true,
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideRouter(appRoutes, withInMemoryScrolling(scrollConfig), withRouterConfig({ paramsInheritanceStrategy: 'always' })),
    provideAnimations(),
    provideAnimationsAsync(),
    provideEnvironmentNgxMask(),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient],
        },
      })
    ),
    importProvidersFrom(MatNativeDateModule),
    provideMomentDateAdapter(),

    {
      provide: APP_INITIALIZER,
      useFactory: initializeAppFactory,
      deps: [UserService, TranslateService, StorageService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    SsrCookieService,
    { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: globalRippleConfig },
  ],
};
